import { useState } from "react";
import Slider from "react-slick";
import LoadingIndicator from "../../sub/components/LoadingIndicator";
import "../../assets/css/slick.css";

const styles = {
  container: {
    height: "40vh",
    position: "relative",
    overflow: "hidden",
  },
  slide: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  image: {
    maxHeight: "40vh",
    height: "auto",
    width: "100%",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
    borderRadius: "8px",
  },
  arrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "30px",
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 2,
  },
  prevArrow: {
    left: "10px",
  },
  nextArrow: {
    right: "10px",
  },
  arrowIcon: {
    display: "block",
    position: "relative",
    bottom: "2px",
    lineHeight: 1,
  },
  prevArrowIcon: {
    right: "1px",
  },
  nextArrowIcon: {
    left: "1px",
  },
};

const PrevArrow = ({ onClick }) => (
  <div style={{ ...styles.arrow, ...styles.prevArrow }} onClick={onClick} role="button" aria-label="Previous slide">
    <span style={{ ...styles.arrowIcon, ...styles.prevArrowIcon }}>&#8249;</span>
  </div>
);

const NextArrow = ({ onClick }) => (
  <div style={{ ...styles.arrow, ...styles.nextArrow }} onClick={onClick} role="button" aria-label="Next slide">
    <span style={{ ...styles.arrowIcon, ...styles.nextArrowIcon }}>&#8250;</span>
  </div>
);

const ImageCarousel = ({ images }) => {
  const [loadedCount, setLoadedCount] = useState(0);
  const totalImages = images?.length || 0;

  const allLoaded = totalImages > 0 && loadedCount >= totalImages;

  const handleImageLoad = () => {
    setLoadedCount((prev) => prev + 1);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <div style={styles.container} role="region" aria-label="Image carousel">
      <LoadingIndicator isLoading={!allLoaded} />

      <Slider {...settings}>
        {images.map((src, idx) => (
          <div style={styles.slide} key={idx} role="group" aria-label={`Slide ${idx + 1} of ${images.length}`}>
            <img
              src={typeof src === "string" ? src : src?.default}
              alt={`Slide ${idx + 1}`}
              style={styles.image}
              onLoad={handleImageLoad}
              onError={handleImageLoad}
              aria-label={`Image ${idx + 1} of ${images.length}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageCarousel;
